var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFInstagramColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0228 2H9.97723C4.46696 2 0 6.46696 0 11.9772V12.0228C0 17.533 4.46696 22 9.97723 22H10.0228C15.533 22 20 17.533 20 12.0228V11.9772C20 6.46696 15.533 2 10.0228 2Z",
    fill: "url(#paint0_linear_288_20687)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0946 6.06909H6.906C5.1963 6.06909 3.80542 7.45998 3.80542 9.16968V14.8313C3.80542 16.541 5.1963 17.9319 6.906 17.9319H13.0946C14.8043 17.9319 16.1951 16.541 16.1951 14.8313V9.16968C16.1951 7.45998 14.8043 6.06909 13.0946 6.06909ZM4.89921 9.16968C4.89921 8.06328 5.7996 7.16288 6.906 7.16288H13.0946C14.201 7.16288 15.1014 8.06328 15.1014 9.16968V14.8313C15.1014 15.9377 14.201 16.8381 13.0946 16.8381H6.906C5.7996 16.8381 4.89921 15.9377 4.89921 14.8313V9.16968Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 14.8841C11.5907 14.8841 12.8848 13.5906 12.8848 12C12.8848 10.4095 11.5914 9.11597 10.0008 9.11597C8.41019 9.11597 7.1167 10.4095 7.1167 12C7.1167 13.5906 8.41019 14.8841 10.0008 14.8841ZM10.0008 10.2105C10.9881 10.2105 11.7911 11.0135 11.7911 12.0007C11.7911 12.988 10.9881 13.791 10.0008 13.791C9.01349 13.791 8.21049 12.988 8.21049 12.0007C8.21049 11.0135 9.01349 10.2105 10.0008 10.2105Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1518 9.58341C13.58 9.58341 13.9289 9.23506 13.9289 8.80611C13.9289 8.37716 13.5807 8.02881 13.1518 8.02881C12.723 8.02881 12.3748 8.37716 12.3748 8.80611C12.3748 9.23506 12.723 9.58341 13.1518 9.58341Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_288_20687",
    x1: 2.92191,
    y1: 19.0781,
    x2: 17.0781,
    y2: 4.92261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#DD2A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#9537B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFInstagramColored);
export default __webpack_public_path__ + "static/media/f-instagram-colored.4a7f704236fe11901fba5d3168961b01.svg";
export { ForwardRef as ReactComponent };